/** One encoded query contract for tables and exports, including fixed parent scopes. */
export function buildTableQuery({ page, limit, sort, filter = [], search, scope = "", extra } = {}) {
  const source = new URLSearchParams(String(scope || "").replace(/^[?&]/, ""));
  const query = new URLSearchParams();
  const scopedFilters = new Map();
  source.forEach((value, key) => {
    const match = key.match(/^filter\[(\d+)\]\[(key|value|operator)\]$/);
    if (match) {
      const entry = scopedFilters.get(Number(match[1])) || {};
      entry[match[2]] = value;
      scopedFilters.set(Number(match[1]), entry);
    } else query.append(key, value);
  });
  if (page != null) query.set("Page", page);
  if (limit) query.set("Limit", limit);
  if (search) query.set("search", search);
  if (extra) query.set(extra.name, extra.value);
  Object.entries(sort || {}).forEach(([key, ascending], index) => {
    query.set(`sort[${index}][key]`, key);
    query.set(`sort[${index}][direction]`, ascending ? "asc" : "desc");
  });
  const entries = [...scopedFilters.entries()].sort(([a], [b]) => a - b).map(([, entry]) => entry);
  for (const item of filter || []) {
    const entry = { key: item.name, value: String(item.value), operator: item.type };
    if (!entries.some((existing) => Object.keys(entry).every((key) => existing[key] === entry[key]))) entries.push(entry);
  }
  entries.forEach((entry, index) => Object.entries(entry).forEach(([key, value]) => query.set(`filter[${index}][${key}]`, value)));
  return query;
}
